export const referentkaFirebaseConfig = {
    apiKey: 'AIzaSyB90r3UVdYLDEB0FrDyjBnCwSfrppTj64c',
    authDomain: 'memowl.firebaseapp.com',
    projectId: 'memowl',
    storageBucket: 'memowl.appspot.com',
    messagingSenderId: '761577021040',
    appId: '1:761577021040:web:71918942989891227e9eb5',
    measurementId: 'G-6275SYC252',
};
